(function () {
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  ready(function () {
    var formButton = document.getElementById('AddToCart');
    var price = document.getElementById('ProductPrice');
    if (formButton && document.body.classList.contains('template-product')) {
      var bar = document.createElement('div');
      bar.className = 'pto-mobile-buybar';
      bar.setAttribute('aria-label', 'Quick add to cart');
      bar.innerHTML = '<span class="pto-mobile-buybar__price"></span><button type="button">Add to cart</button>';
      var barPrice = bar.querySelector('.pto-mobile-buybar__price');
      var barButton = bar.querySelector('button');
      function sync() {
        barPrice.textContent = price ? price.textContent.trim() : '';
        barButton.disabled = !!formButton.disabled;
        barButton.textContent = formButton.disabled ? 'Unavailable' : 'Add to cart';
      }
      sync();
      barButton.addEventListener('click', function () {
        formButton.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center'});
        window.setTimeout(function(){ formButton.click(); }, 220);
      });
      new MutationObserver(sync).observe(formButton, {attributes:true, childList:true, subtree:true});
      if (price) new MutationObserver(sync).observe(price, {childList:true, subtree:true});
      document.body.appendChild(bar);
    }
    if (document.body.classList.contains('template-collection')) {
      var u = new URL(window.location.href);
      if (/\/collections\/all\/?$/.test(u.pathname) && !u.searchParams.has('sort_by')) {
        u.searchParams.set('sort_by', 'best-selling');
        window.location.replace(u.toString());
      }
    }
  });
})();
